<!--suppress InconsistentLineSeparators -->
<template>
    <svg-icon
        v-if="nextStep"
        original
        :name="`navigation/${nextStep.direction}-black`"
        class="mobile-ar-step-icon"
    />
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "MArStepIcon",

    computed:{
        ...mapState({
            activeStep: state => state.activeStep,
            activeStepIndex: state => state.activeStepIndex,
            activePathSteps: state => state.activePath?.steps || [],
        }),
        nextStep(){
            return this.activeStepIndex+1 in this.activePathSteps ?
                this.activePathSteps[this.activeStepIndex+1] : null
        },
    }
}
</script>

<style lang="scss">
@import "m-ar-step-icon";
</style>
